import * as React from 'react'
import PropTypes from 'prop-types'

import CTAButton from '../CTAButton/CTAButton'
import {
  BlockContainer,
  CTAWrapper,
  TextContainer,
  Heading,
  Description,
  CTAButtonWrapper,
  CTAButtonContainer,
} from './styles'

/**
 * CTABlock Component
 * A call-to-action section with a heading and one or two buttons
 */
export default function CTABlock({
  heading = 'Lorem Ipsum Dolor',
  description = '',
  cta1Text = 'Buy Now',
  cta1FontSize = 'medium',
  cta1UseFullWidth = false,
  cta1Link,
  cta1BackgroundColor = 'coral',
  cta1Variant = false,
  cta1Analytics = 'Clicked_Builder CTA',
  hasDualCta = false,
  cta2Text = 'Buy Now',
  cta2FontSize = 'medium',
  cta2UseFullWidth = false,
  cta2Link,
  cta2BackgroundColor = 'coral',
  cta2Variant = false,
  cta2Analytics = 'Clicked_Builder CTA',
}) {
  return (
    <BlockContainer>
      <CTAWrapper>
        <TextContainer>
          <Heading>{heading}</Heading>
          {description && <Description>{description}</Description>}
        </TextContainer>
        <CTAButtonWrapper>
          <CTAButtonContainer>
            <CTAButton
              ctaLink={cta1Link}
              ctaVariant={cta1Variant}
              ctaAnalytics={cta1Analytics}
              backgroundColor={cta1BackgroundColor}
              fontSize={cta1FontSize}
              useFullWidth={cta1UseFullWidth}
            >
              {cta1Text}
            </CTAButton>
          </CTAButtonContainer>
          {hasDualCta && (
            <CTAButtonContainer>
              <CTAButton
                ctaLink={cta2Link}
                backgroundColor={cta2BackgroundColor}
                ctaVariant={cta2Variant}
                ctaAnalytics={cta2Analytics}
                fontSize={cta2FontSize}
                useFullWidth={cta2UseFullWidth}
              >
                {cta2Text}
              </CTAButton>
            </CTAButtonContainer>
          )}
        </CTAButtonWrapper>
      </CTAWrapper>
    </BlockContainer>
  )
}

CTABlock.propTypes = {
  heading: PropTypes.string,
  description: PropTypes.string,
  cta1Text: PropTypes.string,
  cta1FontSize: PropTypes.string,
  cta1UseFullWidth: PropTypes.bool,
  cta1Link: PropTypes.string,
  cta1BackgroundColor: PropTypes.string,
  cta1Variant: PropTypes.bool,
  cta1Analytics: PropTypes.string,
  hasDualCta: PropTypes.bool,
  cta2Text: PropTypes.string,
  cta2FontSize: PropTypes.string,
  cta2UseFullWidth: PropTypes.bool,
  cta2Link: PropTypes.string,
  cta2BackgroundColor: PropTypes.string,
  cta2Variant: PropTypes.bool,
  cta2Analytics: PropTypes.string,
}
